@if (showMobileCategories) {
  <app-categories-mobile
    class="mobile-categories"
    [list]="list"
    [selectedCount]="selectedContentType.length"
    (categoriesEmitter)="updateCategories($event)"
  ></app-categories-mobile>
} @else {
  <div class="categories-wrapper">
    <p class="text-xs text--semi-bold categories-title">{{ 'Categories' | translate }}</p>
    @if (list && list.length) {
      <section>
      <span>
        <mat-checkbox
          [checked]="isAllChecked"
          [indeterminate]="isSomeChecked && !isAllChecked"
          (change)="updateAll()">
          {{ 'All' | translate }}
        </mat-checkbox>
      </span>
        <span>
        <ul>
        @for (item of list; track item.id; let index = $index) {
          <li>
            <mat-checkbox [checked]="item.checked" (change)="update(item)">
              {{ item.name }}
            </mat-checkbox>
            {{ item.count }}
          </li>
        }
      </ul>
      </span>
      </section>
    }
  </div>
}
